export const FETCH_TIME_OFF_REQUESTS_SUCCESS = 'FETCH_TIME_OFF_REQUESTS_SUCCESS';
export const FETCH_TIME_OFF_REQUESTS_FAILURE = 'FETCH_TIME_OFF_REQUESTS_FAILURE';
export const ADD_TIME_OF_REQUEST = 'ADD_TIME_OF_REQUEST';
export const UPDATE_TIME_OF_REQUEST = 'UPDATE_TIME_OF_REQUEST';
export const DELETE_TIME_OF_REQUEST = 'DELETE_TIME_OF_REQUEST';
export const ADD_IS_ON_TIME_OFF_REQUESTS = 'ADD_IS_ON_TIME_OFF_REQUESTS';
export const ADD_GOING_ON_TIME_OFF_REQUESTS = 'ADD_GOING_ON_TIME_OFF_REQUESTS';
export const TIME_OFF_REQUEST_DETAIL_MODAL_OPEN = 'TIME_OFF_REQUEST_DETAIL_MODAL_OPEN';
export const TIME_OFF_REQUEST_DETAIL_MODAL_CLOSE = 'TIME_OFF_REQUEST_DETAIL_MODAL_CLOSE';
